import React, { Fragment, useEffect, useState, useMemo } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import config from "../../config/config";

import { Noimage } from "../../common/imagePath";
import { Box, Button, IconButton, MenuItem, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";
import CommonMatrialReactTable from "../Datatable/CommonMatrialReactTable";
import { toastSuccess } from "../../common/Toast";

function TopCategories(props) {
  const [visibleTopCategories, setVisibleTopCategories] = useState(false);
  const token = localStorage.getItem("Token");
  const [categories, setCategories] = useState(props.visibleCategoriesChange);

  const [data11, setdata11] = useState(true);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [data, setdata] = useState([]);

  const [dynamicValue, setDynamicValue] = useState("MainSite");

  useEffect(() => {
    if (props?.dynamicModule) {
      setDynamicValue(props.dynamicModule);
    }
  }, [props?.dynamicModule]);

  const fetchApi = () => {
    axios
      .get(
        `${config.ecommconfigBaseUrl}/ecomconfig/topcategoriesselect?from=${dynamicValue}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setdata(res.data.ResponseData);
      });
  };

  //UseEffect For Table
  useEffect(() => {
    fetchApi();
  }, [dynamicValue]);

  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
    },
    {
      header: "Category Name",
      accessorKey: "CategoryName",
    },
    {
      header: "Category Image",
      Cell: ({ row }) => (
        <>
          <a target="_blank" href={row.original.ImageName}>
            <img
              src={
                row.original.ImageName ? row.original.ImageName : Noimage //"https://www.freeiconspng.com/uploads/no-image-icon-4.png"
              }
              style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
            />
          </a>
        </>
      ),
    },
  ];

  const callback = (payload) => {
    // if (payload != undefined && payload != null && payload != "") {
    //   let manageolddata = [...featuredProducts, payload];
    //   setFeaturedProducts(manageolddata);
    // }
    fetchApi();
  };

  console.log(data, "categorydata");

  const openDeleteFunction = (row) => {
    const deleteRequestParam = {
      ID: row.original.ID,
      from : dynamicValue
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );

    setDeleteModalOpen(true);
  };

  const muiRowDragHandleProps = ({ table }) => ({
    onDragEnd: () => {
      const { draggingRow, hoveredRow } = table.getState();
      if (hoveredRow && draggingRow) {
        data.splice(hoveredRow.index, 0, data.splice(draggingRow.index, 1)[0]);
        setdata([...data]);
      }
    },
  });

  const handelSaveRowOrder = () => {
    const categoryIdList = data.map((el) => el.ID).join(",");
    const finalData = {
      ids: categoryIdList,
      model: "Category",
      type: "TopCategories",
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/setRowOrder`, finalData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        toastSuccess("Category Row Order Successfully Done");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Fragment>
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">
            <CLink
              className="link"
              onClick={() => {
                setVisibleTopCategories(!visibleTopCategories);
                setCategories(!!categories);
              }}
            >
              Top Categories
            </CLink>
          </h5>
        </div>
        <CCollapse
          visible={visibleTopCategories || props.visibleCategoriesChange}
        >
          <div className="card-body">
            <div className="row">
              <div class="col-6">
                <SearchableDropdown
                  callback={callback}
                  dynamicValue={dynamicValue}
                />
              </div>
              <div className="col-6 d-flex justify-content-end align-items-start">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => handelSaveRowOrder()}
                  style={{ margin: "6px" }}
                >
                  Save Row Order
                </button>
              </div>
            </div>

            <div
              className="table-responsive  mt-4"
              style={{ border: "1px solid rgba(0,0,0,.12)" }}
            >
              <CommonMatrialReactTable
                columns={columns}
                data={data}
                hodiExport={true}
                enableRowSelection={false}
                enableRowOrdering={true}
                muiRowDragHandleProps={muiRowDragHandleProps}
                enableRowActions={true}
                renderRowActions={({ row }) => (
                  <Box>
                    <IconButton onClick={() => openDeleteFunction(row)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                )}
                // renderRowActionMenuItems={({ row }) => [
                //   <MenuItem
                //     className="confirm-text"
                //     to="#"
                //     // key="delete"
                //     title="Delete"
                //     data-bs-toggle="modal"
                //     // data-bs-target="#DeleteConfirmationModal"
                //     onClick={() => openDeleteFunction(row)}
                //   >
                //     <DeleteIcon />
                //     Delete
                //   </MenuItem>,
                // ]}
              />
            </div>
          </div>
        </CCollapse>
      </div>
      <DeleteConfirmationModalBanner
        deleteApiUrl={`${config.ecommconfigBaseUrl}/ecomconfig/deletetopcategories`}
        open={deleteModalOpen}
        data11={data11}
        onClose={() => {
          setDeleteModalOpen(false);
          fetchApi();
        }}
        dynamicValue={dynamicValue}
      />
    </Fragment>
  );
}

// SearchableDropdown
const SearchableDropdown = ({ callback, dynamicValue }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  console.log(suggestions, "44444");
  const [inputValue, setInputValue] = useState("");

  const fetchData = async () => {
    // Return early if inputValue is empty
    if (!inputValue) {
      setSuggestions([]);
      return;
    }

    try {
      // Make the API request
      const response = await axios.get(
        `${config.categoriesBaseUrl}/categories?from=${dynamicValue}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      const data = response.data?.ResponseData;

      // If data exists, filter based on inputValue
      if (data?.length > 0) {
        const filteredData = data.filter((category) =>
          category.Name.toLowerCase().includes(inputValue.toLowerCase())
        );

        // Set the filtered suggestions
        setSuggestions(filteredData);
      } else {
        setSuggestions([]); // Clear suggestions if no data
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setSuggestions([]); // Clear suggestions in case of an error
    }
  };

  useEffect(() => {
    fetchData();
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    // event,
    pItemId,
    pItemName,
    dynamicValue
  ) => {
    const selectedOption = {
      ID: pItemId,
      CategoryName: pItemName,
      dynamicValue: dynamicValue,
    };
    const data = {
      TopCategories: pItemId,
      From: dynamicValue,
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/topcategories`, data, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        toastSuccess("Category Add Successfully Done");
        callback(selectedOption);
        setInputValue("");
        setSuggestions([]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  console.log(suggestions, "suggestionlist");

  return (
    <div className="container">
      <form>
        <div className="mb-3" style={{ width: "400px" }}>
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <i
                class="fa fa-edit fs-3"
                style={{ color: "var(--secondary-main-color)" }}
              ></i>
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div
            className="dropdown"
            style={{ position: "relative", width: "400px" }}
          >
            <ul
              className="dropdown-menu show" //  dropdown-suggestion
              style={{
                // width: "100%",
                maxHeight: "400px",
                overflowY: "auto",
              }}
            >
              {suggestions.map((item, index) => (
                <li
                  key={item.ItemId}
                  onClick={(e) =>
                    handleInputClick(item.ID, item.Name, dynamicValue)
                  }
                  style={{ cursor: "pointer" }}
                  className={"dropdown-item"}
                >
                  <a
                    key={item.ID}
                    className={"dropdown-item"}
                    data-name={item.Name}
                  >
                    <img
                      src={item.Imagename ? item.Imagename : Noimage}
                      onError={(e) => {
                        e.currentTarget.src = Noimage;
                      }}
                      alt={item.Name}
                      className="img-thumbnail rounded-circle mr-5"
                      width="65px"
                      height="65px"
                    />
                    <div className="customer-info">
                      <h6 className="name word-break-data">{item.Name}</h6>
                      <p> Item Id : {item.ID}</p>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
};

export default TopCategories;
